import { render, staticRenderFns } from "./CrossCloseButton.vue?vue&type=template&id=8d6d217c&scoped=true&"
var script = {}
import style0 from "./CrossCloseButton.vue?vue&type=style&index=0&id=8d6d217c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6d217c",
  null
  
)

export default component.exports